import React, { Component } from 'react';
import ordinal from 'ordinal';
import { defineMessages, injectIntl } from 'react-intl';

import Title from './title';
import money, { format } from '../lib/money';
import { Time } from '../../components/Time';
import Payment from '../lib/payment';
import { CAPTURED, PROCESSING_PAYOUT } from '../lib/payment';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  title: {
    id: 'paymentsSchedule.title',
    defaultMessage: 'Individual payment schedule',
  },
  titleGroup: {
    id: 'paymentsSchedule.title.group',
    defaultMessage: 'Payment schedule',
  },
  reservationMessage: {
    id: 'paymentsSchedule.reservationMessage',
    defaultMessage: 'Inventory won\'t be reserved until the group makes payment 1'
  },
  headerPayment: {
    id: 'paymentsSchedule.tableHeaders.payment',
    defaultMessage: 'Payment',
  },
  headerDate: {
    id: 'paymentsSchedule.tableHeaders.dueDeadline',
    defaultMessage: 'Charged by',
  },
  headerAmount: {
    id: 'paymentsSchedule.tableHeaders.amount',
    defaultMessage: 'Amount',
  },
  tableTotal: {
    id: 'paymentsSchedule.table.total',
    defaultMessage: 'Total',
  },
  tableTotalWithFee: {
    id: 'paymentsSchedule.table.total.withFee',
    defaultMessage: 'Total (inc. {fee} fee)',
  },
});

export class PaymentsSchedule extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
    this.payments = this.buildPayments();
  }

  get formattedTotalAmount() {
    const amount = money(this.props.totalAmount);

    if (!amount || amount.isZero()) return '--';

    return format(amount);
  }

  get anyPaymentCaptured() {
    return this.props.payments.some(({ status }) => {
      return status === CAPTURED || status === PROCESSING_PAYOUT;
    });
  }

  get refundableAmount() {
    if (!this.props.refundableAmount) return;
    return money(this.props.refundableAmount);
  }

  get consumerFee() {
    if (!this.props.consumerFee) return;
    return money(this.props.consumerFee);
  }

  get totalAmountText() {
    if (!this.consumerFee || this.consumerFee.isZero()) return this.formatMessage(i18n.tableTotal);
    return this.formatMessage(i18n.tableTotalWithFee, { fee: format(this.consumerFee) });
  }

  buildPayments() {
    const { payments } = this.props;
    const result = [];
    payments.forEach((payment, index) => {
      if (index === payments.length - 1 && this.refundableAmount &&
        !this.refundableAmount.isZero()) {
        result.push({ ...payment, isRefund: true, amount: this.refundableAmount });
      } else {
        result.push({ ...payment, isRefund: false });
      };
    });
    return result;
  }

  printAmount(payment) {
    const { amount, perSlotAmount, isRefund } = payment;
    if (perSlotAmount) return format(perSlotAmount);
    if (!amount) return '--';
    if (isRefund) return `(${format(amount)})`;
    return format(amount);
  }

  printDeadline(payment) {
    if (!payment.amount || !payment.dueDeadline) return '--';
    return <Time time={payment.dueDeadline} />;
  }

  renderCheck(status) {
    if (!Payment.isPaid(status) && !Payment.isCaptured(status)) return null;
    return <i className="fa fa-check fa-fw clear-blue" />;
  }

  renderHelperText() {
    if (this.anyPaymentCaptured) return null;
    return (
      <p className="small-print">{this.formatMessage(i18n.reservationMessage)}</p>
    );
  }

  renderPaymentsDetails() {
    return this.payments.map((payment, index) => {
      const key = `payment-${index}`;
      return (
        <tr key={key}>
          <td>{ordinal(index + 1)}</td>
          <td>{this.printDeadline(payment)}</td>
          <td className={payment.isRefund ? 'emerald-green' : ''}>
            {this.printAmount(payment)}
            {this.renderCheck(payment.status)}
          </td>
        </tr>
      )
    });
  }

  render() {
    return (
      <div className="payment-schedule">
        <Title
          text={this.formatMessage(this.props.forMember ? i18n.title : i18n.titleGroup)}
          divider
        />
        {this.renderHelperText()}
        <table className="table">
          <thead>
            <tr>
              <th className="small-print">
                {this.formatMessage(i18n.headerPayment)}
              </th>
              <th className="small-print">
                {this.formatMessage(i18n.headerDate)}
              </th>
              <th className="small-print">
                {this.formatMessage(i18n.headerAmount)}
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderPaymentsDetails()}
            <tr className="divider">
              <td colSpan="2" className="text-right cool-grey">
                {this.totalAmountText}
              </td>
              <td>{this.formattedTotalAmount}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

PaymentsSchedule.defaultProps = {
  payments: [],
  forMember: false,
};

export default injectIntl(PaymentsSchedule);



// WEBPACK FOOTER //
// ./src/desktop/components/payments-schedule.js